$(function () {
    let currentSize = null;

    const redraw = function () {
        const bp = $('<div style="position: absolute; left: -10000px;"><div class="d-none d-xxl-block" data-bp="xxl"></div><div class="d-none d-xl-block" data-bp="xl"></div><div class="d-none d-lg-block" data-bp="lg"></div><div class="d-none d-md-block" data-bp="md"></div><div class="d-none d-sm-block" data-bp="sm"></div></div>');
        const size = bp.appendTo('body').children(':visible').first().data('bp') || 'xs';
        bp.remove();
        if (currentSize === size) { return; }
        currentSize = size;

        // redo the order of the items, depending on the columns found
        // we assume that all .index-grid have the same grid layout. So we need the first visible one to meassure how big all the others are
        const $firstVisible = $('.index-grid:visible').first();
        if (!$firstVisible.length) { return; }

        const columns = Math.round(100 / ($firstVisible.children().first().outerWidth() / $firstVisible.outerWidth() * 100));
        // remove all items that were added as spacers
        $('.index-grid .placeholder').remove();
        $('.index-grid').each(function () {
            const $this = $(this);
            const children = [];
            $this.children().each(function() {
                const $c = $(this);
                children.push({
                    text: $c.find('a').text().toLowerCase(),
                    element: $c
                });
            });
            children.sort(function (a, b) {
                if (a.text > b.text) {
                    return 1;
                } else if (a.text < b.text) {
                    return -1;
                } else {
                    return 0;
                }
            });

            const rows = Math.ceil(children.length / columns);
            const placeholderChildren = (rows * columns) - children.length;
            // add placeholders for all the grids where the row is not full
            for (let index = 0; index < placeholderChildren; index++) {
                const $c = $('<li class="placeholder"></li>');
                $c.appendTo($this);
                children.push({
                    text: '',
                    element: $c
                });
            }

            let targetIndex = 0;
            for (let row = 0; row < rows; row++) {
                for (let column = 0; column < columns; column++) {
                    var index = (column * rows) + row;
                    children[index].element.css('order', targetIndex + 1);
                    targetIndex++;
                    
                }
            }
        });
    };

    $(window).on('resize', redraw);
    redraw();
});